<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-link class="brand-logo">
        <logo />

        <h2 class="brand-text text-primary ml-1">Amini Finance</h2>
      </b-link>
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1"> تایید ثبت نام </b-card-title>

          <validation-observer ref="verifyForm" #default="{ invalid }">
            <b-form class="auth-verify-form mt-2" @submit.prevent="verify">
              <b-form-group
                label="کد ارسال شده را وارد کنید"
                label-for="register-code"
              >
                <validation-provider
                  #default="{ errors }"
                  name="code"
                  vid="code"
                  rules="required|min:6"
                >
                  <b-form-input
                    autocomplete="on"
                    id="register-code"
                    v-model.trim="code"
                    name="register-code"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <p class="text-center mt-2">
                <b-link @click="resend">
                  <span>ارسال مجدد</span>
                  <span class="mx-1">
                    <vue-countdown
                      :time="180000"
                      @end="onCountdownEnd"
                      v-slot="{ totalSeconds }"
                      >{{ totalSeconds }}
                    </vue-countdown>
                  </span>
                </b-link>
              </p>
              <b-button
                variant="primary"
                block
                type="submit"
                :disabled="invalid"
              >
                تایید
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{ name: 'auth-register' }">
              <feather-icon icon="ChevronLeftIcon" /> برگشت به صفحه ثبت نام
            </b-link>
          </p>
          <div class="divider my-2"></div>
          <div
            class="auth-footer-btn d-flex justify-content-around align-items-baseline"
          >
            <b-card-text class="text-center mt-2">
              <span class="mr-1">شماره پشتیبانی</span>
              <b-link href="tel:+989191952581">
                <span>09191952581</span>
              </b-link>
            </b-card-text>

            <b-button
              variant="gradient-danger"
              class="btn-icon"
              href="https://instagram.com/amini.finance"
            >
              <feather-icon icon="InstagramIcon" />
            </b-button>
          </div>
        </b-col>
      </b-col>
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Register V2" />
        </div>
      </b-col>
    </b-row>
    <loader :loading="loading" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Logo from "@core/layouts/components/Logo.vue";
import VueCountdown from "@chenfengyuan/vue-countdown";
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";
export default {
  components: {
    Logo,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    Loader,
    VueCountdown,
  },
  data() {
    return {
      code: "",
      loading: false,
      sideImg: require("@/assets/images/login.png"),
      required,
      resendIsOn: true,
    };
  },
  watch: {
    code(val) {
      this.code = this.p2e(val).toLowerCase();
    },
  },
  computed: {
    imgUrl() {
      if (this.$store.state.appConfig.layout.skin === "dark") {
        this.sideImg = require("@/assets/images/login.png");
        return this.sideImg;
      }
      return this.sideImg;
    },
    userName() {
      return this.$store.state.auth.userName;
    },
    device() {
      return this.$store.state.appConfig.device;
    },
  },
  created() {
    if (!Object.keys(this.userName).length)
      this.$router.replace({ name: "auth-register" });
  },
  methods: {
    onCountdownEnd() {
      this.resendIsOn = true;
    },
    async resend() {
      this.loading = true;
      try {
        const { data } = await this.$http.post("/auth/register/resend", {
          username: this.userName,
        });
        this.resendIsOn = false;
        this.loading = false;
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: `کد تایید ثبت نام با موفقیت برای شما ارسال شد.`,
              icon: "InfoIcon",
              variant: "success",
            },
          },
          { position: "bottom-right" }
        );
      } catch (err) {
        this.loading = false;
      }
    },
    verify() {
      this.$refs.verifyForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            const { data } = await this.$http.post("/auth/register/verify", {
              username: this.userName,
              code: this.code,
              device_name: this.device,
            });
            this.$http.defaults.headers.common[
              "Authorization"
            ] = `${data.data.type} ${data.data.token}`;
            await localStorage.setItem(
              "userData",
              JSON.stringify(data.data.user)
            );
            await this.$store.dispatch("auth/setUserData", data.data.user);
            await localStorage.setItem(
              "token",
              JSON.stringify(data.data.token)
            );
            const isAdmin =
              (await data.data.user.permissions.permissions.length) > 0;
            await this.$store.commit(
              "appConfig/UPDATE_NAV_MENU_HIDDEN",
              Object.keys(data.data.user).length == 0
            );
            if (!data.data.user.mobile_verified_at) {
              this.$store.dispatch("auth/setVisibleCheckUser", true);
              this.$store.dispatch("auth/setVerifyType", "mobile");
            }
            if (!data.data.user.email_verified_at) {
              this.$store.dispatch("auth/setVisibleCheckUser", true);
              this.$store.dispatch("auth/setVerifyType", "email");
            }
            this.loading = false;
            this.$router
              .replace(isAdmin ? "/dashboard" : "/profile/road-map")
              .then(() => {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: ` ${
                        data.data.user.first_name +
                        " " +
                        data.data.user.last_name
                      } خوش آمدید.`,
                      icon: "CoffeeIcon",
                      variant: "success",
                    },
                  },
                  { position: "bottom-right" }
                );
              });
          } catch (err) {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
